import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';
import { ErrorResponse } from '../../applicationinfraestructure/interfaces/error-response';
import { IEdificios } from '../interfaces/Edificios';
import { IFiltrosReporteVentaCertificada } from '../interfaces/FiltrosReporteVentaCertificada';
import { ExcelService } from '../Services/excel.service';
import { RegistroVentasService } from '../Services/registro-ventas.service';




@Component({
  selector: 'app-reporte-ventas-certificadas',
  templateUrl: './reporte-ventas-certificadas.component.html',
  styleUrls: ['./reporte-ventas-certificadas.component.css']
})
export class ReporteVentasCertificadasComponent implements OnInit {
  
  formReporte: FormGroup;
  filtros: IFiltrosReporteVentaCertificada;
  submitted = false;
  error:any={isError:false,errorMessage:''};
  edificios: Array<IEdificios>;

  constructor(private excelService:ExcelService,
    private spinner: NgxSpinnerService,
    private readonly formBuilder: FormBuilder,
    private registroServicios: RegistroVentasService) { }

  ngOnInit(): void {
    this.construirFromularioReporte();
    this.getEdificiosConsulta(environment.edificiosAutorizados, environment.marcasAutorizadas);
  
  }

  construirFromularioReporte() {
    this.formReporte = this.formBuilder.group({
      fechaInicio: ['', Validators.required],
      fechaFin: ['', Validators.required],
      edificio: [''],
      marca:[''],
      tipoContrato: ['']
    });
  }
  get f() { return this.formReporte.controls; }

  getEdificiosConsulta(edificios: string, marcas: string) {
    this.registroServicios.getEdificiosConsulta(edificios, marcas).subscribe(
      resolve => {
        if (resolve.length != 0) {
          this.edificios = resolve;
        }

      },
      (error: ErrorResponse) => {
        console.error(error);
       
      }
    );
  }
 
  exportAsXLSX(): void {
    this.spinner.show();
    const filtros: IFiltrosReporteVentaCertificada = {
      ...this.formReporte.value
    };

    this.registroServicios.getConsultaReporteVentasCertificadas(filtros).subscribe(
      resolve => {
        if (resolve.length != 0) {
            this.  excelService.exportAsExcelFile( resolve, 'reporte_ventas_certificadas');
          
        }
        else
        {
          Swal.fire('No se encontraron registros.');
         
        }
        this.spinner.hide();

      },
      (error: ErrorResponse) => {
        console.error(error);
        this.spinner.hide();
      }
    );
  }

  compareTwoDates(){
    if((this.formReporte.controls['fechaFin'].value)<(this.formReporte.controls['fechaInicio'].value)){
       this.error={isError:true,errorMessage: 'La fecha fin no debe ser mayor a la fecha inicial'};
    }
    else{
     this.error={isError:false,errorMessage: ''};
    }
 }

 estadosContrato = [
  { id: 'Fijo', name: 'Fijo' },
  { id: 'Variable', name: 'Variable'}
];

}
